import React from 'react';
import parse from 'html-react-parser';

const QuestionaireTextBlockConfirm = ({id, text, confirm, index, required, answer, onAnswer }) => {
    const jsonUnescape = (str) =>{
        const x =   str.replace(/&#39;/g, "'").replace(/&#34;/, "\"").replace(/\\\\/g, "\\").replace(/\\n\\r/g, "<br/>").replace(/\\r\\n/g, "<br/>").replace(/\\r/g, "<br/>").replace(/\\n/g, "<br/>").replace(/\n/g, "<br/>").replace(/\r/g, "<br/>");
        return x;
    }
    return ( 
        <React.Fragment>
            <div>
                <div className="form-group mt-4">
                    {parse(jsonUnescape(text))}
                </div>
                <div class="form-check mt-4"  key={id}>
                    <input class="form-check-input" type="checkbox" value={id} checked={!!answer.answer} name={id} id={id} required={required} value={id}  autoFocus={id===1? true: false } onClick={(e) => {onAnswer(id, !answer.answer)}}></input>
                    <label class="form-check-label" for={id}>
                    {parse(jsonUnescape(confirm))}
                    </label>
                </div>                                
            </div>
        </React.Fragment>
        

     );
}
export default QuestionaireTextBlockConfirm;